'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hubspotUrlinator = require('hubspot.urlinator.Url');

var _hubspotUrlinator2 = _interopRequireDefault(_hubspotUrlinator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generateNextUrl(currentChannelParam, nextChannel) {
  var currentUrl = window.location.href;
  var hasQueryParams = currentUrl.indexOf('?') > -1 && currentUrl.indexOf('=') > -1;

  if (nextChannel === null) {
    return currentUrl.split('?')[0];
  } else if (hasQueryParams && currentUrl.indexOf('currentChannel') > -1) {
    return currentUrl.replace(currentChannelParam, nextChannel);
  } else if (hasQueryParams) {
    return currentUrl + '&currentChannel=' + nextChannel;
  }

  return currentUrl.split('?')[0] + '?currentChannel=' + nextChannel;
}

exports.default = function (store) {
  return function (next) {
    return function (action) {
      var prevChannel = store.getState().currentChannel;
      var toReturn = next(action);
      var newChannel = store.getState().currentChannel;

      if (prevChannel !== newChannel) {
        var url = new _hubspotUrlinator2.default(window.location);
        var currentChannelParam = url.paramValue('currentChannel');

        if (currentChannelParam !== newChannel) {
          var nextUrl = generateNextUrl(currentChannelParam, newChannel);
          window.history.replaceState(null, document.title, nextUrl);
        }
      }

      return toReturn;
    };
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/middleware/QueryParamMiddleware.js
// module id = 487
// module chunks = 0